import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

// Attach token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 globally
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// ─── Auth ───
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  me: () => api.get('/auth/me'),
};

// ─── Resume ───
export const resumeAPI = {
  upload: (formData) =>
    api.post('/resume/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  list: () => api.get('/resume/list'),
  get: (id) => api.get(`/resume/${id}`),
};

// ─── Interview ───
export const interviewAPI = {
  start: (data) => api.post('/interview/start', data),
  submitAnswer: (id, data) => api.post(`/interview/${id}/answer`, data),
  submitVoiceAnswer: (id, formData) =>
    api.post(`/interview/${id}/answer-voice`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  end: (id) => api.post(`/interview/${id}/end`),
  history: () => api.get('/interview/history'),
  report: (id) => api.get(`/interview/${id}/report`),
};

export default api;
